const updates = [
  {
    time: '今日 20:00',
    title: '《长安如故》第38集更新',
    desc: '白鹿任嘉伦虐心名场面来袭，全网热议',
    tag: '国产剧',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    time: '今日 18:30',
    title: '《财阀家的小儿子》第12集上线',
    desc: '宋仲基复仇计划进入白热化阶段',
    tag: '韩剧',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    time: '今日 15:00',
    title: '《风骚律师》最终季全集放送',
    desc: 'IMDb 9.0分神作，绝命毒师前传完结',
    tag: '美剧',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    time: '昨日 22:00',
    title: '《莲花楼》加更两集',
    desc: '成毅古装探案新高度，热度破万',
    tag: '国产剧',
    tagColor: 'bg-primary-100 text-primary-700',
  },
  {
    time: '昨日 19:00',
    title: '《与恶魔有约》全集上架',
    desc: '金裕贞宋江奇幻爱情喜剧高甜来袭',
    tag: '韩剧',
    tagColor: 'bg-accent-100 text-accent-700',
  },
  {
    time: '7月30日',
    title: '《真探》第四季蓝光版上线',
    desc: '朱迪·福斯特主演，极地暗黑探案',
    tag: '美剧',
    tagColor: 'bg-secondary-100 text-secondary-700',
  },
  {
    time: '7月29日',
    title: '《大奉打更人》超前点播开启',
    desc: '王鹤棣田曦薇爆笑古装探案喜剧',
    tag: '国产剧',
    tagColor: 'bg-primary-100 text-primary-700',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            更新速递
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            最新电视剧更新动态，第一时间掌握追剧节奏
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, i) => (
            <div
              key={i}
              className="relative flex gap-4 pb-6 md:pb-8 last:pb-0 group cursor-pointer"
            >
              <div className="flex flex-col items-center">
                <div className="w-3 h-3 rounded-full bg-primary-500 flex-shrink-0 mt-1.5 group-hover:scale-125 transition-transform"></div>
                {i < updates.length - 1 && (
                  <div className="w-px flex-1 bg-background-200 mt-1.5"></div>
                )}
              </div>

              <div className="flex-1 min-w-0 pb-2">
                <div className="flex flex-wrap items-center gap-2 mb-1.5">
                  <span className="text-xs text-foreground-500">{item.time}</span>
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${item.tagColor}`}>
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}